// 距离某个时间几个小时之后的时间
export function getTimeLeftToSomeHourLater(date, hours) {
  // 2019/6/26 10:00:00 或者 2019-6-26 10:00:00
  let _date = ''
  _date = date
  let now = new Date().getTime()

  let later = new Date(_date).getTime() + 1000 * 60 * 60 * hours
  let resDate = new Date(later).getTime()

  let diff = resDate - now

  if (diff > 0) {
    let leftSecond = parseInt(diff / 1000)
    let Day = Math.floor(leftSecond / (60 * 60 * 24))
    let Hour = Math.floor((leftSecond - Day * 24 * 60 * 60) / 3600)
    let Minute = Math.floor((leftSecond - Day * 24 * 60 * 60 - Hour * 3600) / 60)
    let Second = Math.floor(leftSecond - Day * 24 * 60 * 60 - Hour * 3600 - Minute * 60)
    return {
      d: Day,
      h: Hour,
      m: Minute,
      s: Second
    }
  } else {
    return ''
  }

}
import axios from 'axios';

export function uploadImgToQiniu(file, QiniuData) {
  // file图片的文本流   QiniuData{key：'',token:''} key：`KSAX/System/image/${new Date().getTime()}.png` token：七牛token
  let qiniuImgUrl = ''
  const axiosInstance = axios.create({
    withCredentials: false
  }); //withCredentials 禁止携带cookie，带cookie在七牛上有可能出现跨域问题
  let data = new FormData();
  data.append('token', QiniuData.token);
  data.append('file', file);
  data.append('key', QiniuData.key);
  return new Promise((resolve, reject) => {
    axiosInstance({
      method: 'POST',
      url: 'https://up.qiniup.com', //上传地址
      data: data,
      timeout: 30000, //超时时间，因为图片上传有可能需要很久
    }).then(data => {
      qiniuImgUrl = `http://qiniuimage.kuaishouaxiu.com/${data.data.key}`
      resolve(qiniuImgUrl)
      //上传成功...  (登录七牛账号，找到七牛给你的 URL地址) 和 data里面的key 拼接成图片下载地址
    }).catch(function (err) {
      //上传失败
      reject(err)
    });
  })
}